import { Routes } from '@angular/router';
import { AppLayout } from '../app/shared/layout/components/app.layout';
import { Notfound } from './features/acesso/404/404';
import { authGuard } from '../app/core/guards/auth.guard';


/*
export const appRoutes: Routes = [

  // REDIRECIONA RAIZ PARA LOGIN
  { path: '', redirectTo: 'login', pathMatch: 'full' },



  // ADIÇÃO 1: Trata o redirecionamento inicial online
  { path: 'portalfornecedor', redirectTo: 'login', pathMatch: 'full' },
  // ADIÇÃO 2: Trata o carregamento dos componentes quando a URL tem o prefixo
  {
    path: 'portalfornecedor',
    loadChildren: () => import('./features/acesso/login.routes')
  },

  

  // ROTAS PÚBLICAS
  {
    path: '',
    loadChildren: () => import('./features/acesso/login.routes')
  },

  // ROTAS PROTEGIDAS
  {
    path: 'pages',
    component: AppLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      { path: '', loadChildren: () => import('./features/pages.routes') }
    ]
  },

  { path: 'notfound', component: Notfound },
  { path: '**', redirectTo: '/notfound' }
  
];

*/


export const appRoutes: Routes = [
  // 1. Tratamento de redirecionamento inicial (Local e Online)
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'portalfornecedor', redirectTo: 'login', pathMatch: 'full' },

  // 2. Agrupamento de rotas (Tudo o que vem depois do prefixo ou da raiz)
  {
    path: '',
    // Aqui você pode decidir se quer repetir o bloco 'pages' para o prefixo
    // ou simplesmente deixar as rotas fluírem
    children: [
      // ROTAS PÚBLICAS
      {
        path: '',
        loadChildren: () => import('./features/acesso/login.routes')
      },
      // ROTAS PROTEGIDAS
      {
        path: 'pages',
        component: AppLayout,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
          { path: '', loadChildren: () => import('./features/pages.routes') }
        ]
      }
    ]
  },

  // 3. Fallback para quando o prefixo online for usado em qualquer sub-rota
  {
    path: 'portalfornecedor',
    children: [
      { path: '', loadChildren: () => import('./features/acesso/login.routes') },
      { 
        path: 'pages', 
        component: AppLayout, 
        canActivate: [authGuard], 
        children: [{ path: '', loadChildren: () => import('./features/pages.routes') }] 
      }
    ]
  },

  { path: 'notfound', component: Notfound },
  { path: '**', redirectTo: '/notfound' }
];